export default {"src":"/_next/static/media/mock_dummy_mobile_account.9e7dcb4d.svg","height":18,"width":269,"blurWidth":0,"blurHeight":0};